import { FC, useState } from "react";

import FacilityMapViewer from "./FacilityMapViewer";

const FacilityMap: FC<{ mapImageUrl: string | null }> = ({ mapImageUrl }) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  if (!mapImageUrl) return null;

  return (
    <>
      <button
        type="button"
        onClick={() => setIsFullscreen(true)}
        className="group block w-full overflow-hidden rounded-2xl border border-white/[0.06] bg-white/[0.02] text-left transition-colors hover:border-white/10"
      >
        <div className="flex items-center justify-between border-b border-white/[0.06] px-4 py-2.5">
          <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-white/25">
            Facility Map
          </p>
          <span className="flex items-center gap-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-white/30 transition-colors group-hover:text-white/50">
            Tap to expand
            <svg
              className="size-3"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={2}
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
              />
            </svg>
          </span>
        </div>
        <img
          src={mapImageUrl}
          alt="Basecamp facility map"
          className="block w-full bg-white object-contain"
        />
      </button>

      {isFullscreen && (
        <FacilityMapViewer
          mapImageUrl={mapImageUrl}
          onClose={() => setIsFullscreen(false)}
        />
      )}
    </>
  );
};

export default FacilityMap;
